import React, { useEffect } from 'react';
import { FC } from 'react';
import { useSequenceStore } from '~/training/sequence/SequenceStore';
import { useGlobalMediaStore } from '~/ui/video-player/GlobalMediaProvider';
import { registry } from '../Item';
import { CLOSE_CARD, ItemIds } from '../itemIds';
import { InformationCardButton } from '../doors/components/information/InformationCardButton';
import { Item } from '../Item';
import { useEditorStore } from '~/shell/Store';
import { useDoorsStore } from '../doors/DoorsStore';

export const CloseCard: FC<{
  isSubmit?: boolean;
  text?: string;
  isBlocked?: boolean;
  linkedAudioId?: string;
  cardId?: string;
}> = ({ isSubmit, text, isBlocked, linkedAudioId, cardId }) => {
  const dispatchClose = () => {
    window.dispatchEvent(
      new CustomEvent('close-door-card', { detail: { cardId } })
    );
  };
  const audioItem = undefined as any;
  const pictureItem = undefined as any;
  const removedAudio = false;
  const { markDoorCompleted } = useDoorsStore();
  const { audioPlayed } = useSequenceStore();
  const { updateFile, contentEditable, updateSequence } = useEditorStore();
  const globalMedia = useGlobalMediaStore();
  const globalPlayer = globalMedia?.player;

  if (globalPlayer && globalPlayer.controlBar) {
    globalPlayer.controls(true);
  }

  const handleClickButton = (isClose: boolean, doorId?: string) => {
    // body editing handled inside dedicated modals now
    if (!isClose && contentEditable && removedAudio && cardId !== undefined) {
      updateSequence(cardId, 'audios', null);
    }

    if (!isClose && contentEditable && audioItem) {
      updateFile(audioItem.id, audioItem.file, audioItem.type);
    }
    if (!isClose && contentEditable && pictureItem) {
      updateFile(pictureItem.id, pictureItem.file, pictureItem.type);
    }
    if (!disabled) {
      if (doorId) {
        markDoorCompleted(doorId);
      }
      if (globalPlayer && contentEditable) globalMedia.cleanupPlayer?.();
      dispatchClose();
    }
  };
  const disabledButton = globalPlayer && !contentEditable ? true : false;
  const disabled =
    disabledButton ||
    (linkedAudioId && !contentEditable ? !audioPlayed[linkedAudioId] : false);
  if (isBlocked || isSubmit) {
    return (
      <div
        className="closeCard"
        // role="button"
        // tabIndex={0}
        style={{
          alignSelf: 'center',
          marginBottom: isBlocked ? '20px' : '0px'
        }}
      >
        <InformationCardButton
          text={isBlocked ? 'Got it!' : text || 'Submit'}
          disabled={disabled}
          handleClickButton={() => handleClickButton(false, cardId)}
        />
      </div>
    );
  }
  return null;
};

class CloseCardItem extends Item<
  typeof CLOSE_CARD,
  { isSubmit?: boolean; text?: string }
> {
  constructor(definition: any, parent: Item<ItemIds, unknown>) {
    super(definition, parent);
  }

  render(props: any) {
    const { isSubmit, text, isBlocked, linkedAudioId, cardId } = props || {};
    return (
      <CloseCard
        isSubmit={isSubmit}
        text={text}
        isBlocked={isBlocked}
        linkedAudioId={linkedAudioId}
        cardId={cardId}
      />
    );
  }
}
registry[CLOSE_CARD] = CloseCardItem;
